const $ = jQuery.noConflict()

import MobileHeader from '../__header/mobileHeader';
import Accordion from '../__shortcodes/accordions';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll, { markCurrentNavItem } from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import vhUnit from '../__utils/vhUnit';
import AlertBar from '../__header/AlertBar';
import tabs from '../__page/tabs';
import VideoLightbox from '../__page/VideoLightbox';

const headerMobile = new MobileHeader();

window.isScrolled = false

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
        headerMobile.init();
        Accordion.init();
        Video.init();
        mirrorHover();
        smoothScroll();
        Tables.init();
        vhUnit();
        AlertBar();
        VideoLightbox.init()
        tabs.init()
        VideoLightbox.resized();

        if ( window.scrollY > $('.lp-hero').outerHeight() ) {
            document.body.classList.add('is-scrolled')
            window.isScrolled = true
        }
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        Forms();
        vhUnit();
    },
    resized() {
        headerMobile.resized();
        Tables.toggleShadow();
        vhUnit();
        VideoLightbox.resized();
    },
    keyDown(e){
        VideoLightbox.keyDown(e);
    },
    scrolled() {
        markCurrentNavItem()

        if ( window.scrollY > $('.lp-hero').outerHeight() && ! window.isScrolled ) {
            document.body.classList.add('is-scrolled')
            window.isScrolled = true
        } else if ( window.scrollY <= $('.lp-hero').outerHeight() && window.isScrolled ) {
            document.body.classList.remove('is-scrolled')
            window.isScrolled = false
        }
    },
    keyDown(e){

    },
    mouseUp(e) {
        headerMobile.hideOutsideClick(e);
    },
};
export default controller;
